import AdultSymptomExercisePage from '@/components/AdultSymptomExercisePage';
import { isAdultExerciseGroup } from '@/lib/data/contentCatalog';
import { createFileRoute } from '@tanstack/react-router'
import ExerciseImage from "@/assets/exercise-background-photos/concentration.jpg";
import concentrationVideo1Mp4 from '@/assets/videos/adults-symptoms/concentration/concentration-part-1.mp4';
import concentrationVideo1Webm from '@/assets/videos/adults-symptoms/concentration/concentration-part-1.webm';
import concentrationVideo2Mp4 from '@/assets/videos/adults-symptoms/concentration/concentration-part-2.mp4';
import concentrationVideo2Webm from '@/assets/videos/adults-symptoms/concentration/concentration-part-2.webm';
import concentrationVideo3Mp4 from '@/assets/videos/adults-symptoms/concentration/concentration-part-3.mp4';
import concentrationVideo3Webm from '@/assets/videos/adults-symptoms/concentration/concentration-part-3.webm';
import concentrationPoster from '@/assets/concentration-poster.png';
import concentrationPart1Ar from '/subs/concentration-part-1.ar.vtt';
import concentrationPart1En from '/subs/concentration-part-1.en.vtt';
import concentrationPart2Ar from '/subs/concentration-part-2.ar.vtt';
import concentrationPart2En from '/subs/concentration-part-2.en.vtt';
import concentrationPart3Ar from '/subs/concentration-part-3.ar.vtt';
import concentrationPart3En from '/subs/concentration-part-3.en.vtt';
import { useLocaleStore } from '@/lib/stores/localeStore';

export const Route = createFileRoute('/(content)/adults/exercises/concentration/')({
   component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    group: isAdultExerciseGroup(search.group) ? search.group : undefined,
    mode: (search.mode === 'videos' || search.mode === 'exercises') ? search.mode as 'videos' | 'exercises' : undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Concentration Problems - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "concentration.title",
    navbar: {
      transparent: true,
      showTitle: false,
    },
  }),
});

function RouteComponent() {
  const { group, mode } = Route.useSearch();
  const navigate = Route.useNavigate();
  const locale = useLocaleStore((state) => state.locale);
  const captionsDir: 'ltr' | 'rtl' = locale === 'ar' ? 'rtl' : 'ltr';
  const videos = [
    {
      sources: [
        { src: concentrationVideo1Webm, type: 'video/webm' },
        { src: concentrationVideo1Mp4, type: 'video/mp4' },
      ],
      subtitleTracks: [
        { src: concentrationPart1Ar, srcLang: 'ar', label: 'Arabic', default: true },
        { src: concentrationPart1En, srcLang: 'en', label: 'English' },
      ],
      activeSubtitleLanguage: locale === 'ar' ? 'ar' : 'en',
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
    {
      sources: [
        { src: concentrationVideo2Webm, type: 'video/webm' },
        { src: concentrationVideo2Mp4, type: 'video/mp4' },
      ],
      subtitleTracks: [
        { src: concentrationPart2Ar, srcLang: 'ar', label: 'Arabic', default: true },
        { src: concentrationPart2En, srcLang: 'en', label: 'English' },
      ],
      activeSubtitleLanguage: locale === 'ar' ? 'ar' : 'en',
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
    {
      sources: [
        { src: concentrationVideo3Webm, type: 'video/webm' },
        { src: concentrationVideo3Mp4, type: 'video/mp4' },
      ],
      subtitleTracks: [
        { src: concentrationPart3Ar, srcLang: 'ar', label: 'Arabic', default: true },
        { src: concentrationPart3En, srcLang: 'en', label: 'English' },
      ],
      activeSubtitleLanguage: locale === 'ar' ? 'ar' : 'en',
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
  ];

  return (
    <AdultSymptomExercisePage
      symptom="concentration"
      titleKey="concentration.title"
      heroImage={ExerciseImage}
      poster={concentrationPoster}
      videos={videos}
      mode={mode}
      onModeChange={(nextMode) =>
        navigate({
          to: Route.to,
          search: {
            mode: nextMode ?? undefined,
            group: nextMode === 'exercises' ? group : undefined,
          },
        })
      }
      selectedGroup={group}
      onSelectGroup={(nextGroup) =>
        navigate({
          to: Route.to,
          search: { mode: 'exercises', group: nextGroup },
        })
      }
    />
  );
}
